<template>
  <div>
    <link
      href="https://fonts.googleapis.com/css2?family=Edu+NSW+ACT+Foundation:wght@400..700&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&family=Workbench&display=swap"
      rel="stylesheet"
    />
    <div
      v-if="$store.state.appLoaded === true"
      id="app-container"
      class="relative flex flex-col min-h-screen"
    >
      <NavBar
        v-if="shouldShowAppBar && !isMobileView"
        :class="[
          'absolute top-0 right-0 z-10 sidebar-offset',
          sidebarCollapsed ? 'left-20' : 'left-72',
        ]"
      />
      <MobileNavBar v-if="shouldShowAppBar && isMobileView" />
      <div class="flex flex-grow">
        <SideBar
          v-if="shouldShowAppBar && !isMobileView"
          class="text-white z-0"
        />
        <MobileSideBar v-if="shouldShowAppBar && isMobileView" />
        <main
          :class="{
            'with-app-bar': shouldShowAppBar,
            'flex-1 p-4 flex-grow': true,
          }"
        >
          <router-view
            :class="
              !isMobileView && shouldShowAppBar
                ? ['sidebar-offset', sidebarCollapsed ? 'ml-20' : 'ml-72']
                : []
            "
          />
        </main>
      </div>
      <SnackBar />
      <NewGlobalTimer v-if="shouldShowGlobalTimer" />
    </div>
    <div v-else>
      <CircularLoader class="mt-7" />
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import SnackBar from "./components/SnackBar.vue";
import CircularLoader from "./components/CircularLoader.vue";
import SideBar from "./components/Bars/SideBar.vue";
import MobileSideBar from "./components/Bars/NavDrawer.vue";
import NavBar from "./components/Bars/NavBar.vue";
import MobileNavBar from "./components/Bars/NavBarMobile.vue";
import NewGlobalTimer from "./components/GlobalTimer/GlobalTimer.vue";
import { auth } from "./firebase/firebaseConfig.js";

export default {
  components: {
    SnackBar,
    CircularLoader,
    SideBar,
    MobileSideBar,
    NavBar,
    NewGlobalTimer,
    MobileNavBar,
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    // Se decide una sola vez por userAgent (no cambia al redimensionar la ventana).
    const isMobileView = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
    store.commit("setIsMobileView", isMobileView);

    const trackerRunning = computed(() => store.getters.isTimerActive);
    const sidebarCollapsed = computed(() => store.getters.sidebarCollapsed);

    const excludedRoutes = [
      "/login",
      "/register-v2",
      "/forgot-password",
      "/register-resource",
    ];

    const shouldShowAppBar = computed(() => {
      return !excludedRoutes.includes(route.path) && !!auth.currentUser;
    });

    const shouldShowGlobalTimer = computed(() => {
      return trackerRunning.value && !excludedRoutes.includes(route.path);
    });

    return {
      sidebarCollapsed,
      shouldShowAppBar,
      shouldShowGlobalTimer,
      isMobileView,
    };
  },
};
</script>

<style>
html,
body,
#app-container {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app-container {
  font-family: "Poppins", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.with-app-bar {
  margin-top: 60px;
}

.flex-grow {
  flex-grow: 1;
}

/* Acompaña la animación de ancho del SideBar */
.sidebar-offset {
  transition: left 0.25s ease, margin-left 0.25s ease;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-offset {
    transition: none;
  }
}
</style>